import React from "react";
import { useTranslation } from "react-i18next";
import ConfirmationModal from "@/components/layouts/ConfirmationModal";

const TRANSLATION_KEY = "settings.deals.fieldManagement.hideValueModal";

interface HideValueModalProps {
  open: boolean;
  valueName: string;
  onCancel: () => void;
  onConfirm: () => void;
}

/** Confirmation shown when hiding a value that records currently use. */
const HideValueModal: React.FC<HideValueModalProps> = ({
  open,
  valueName,
  onCancel,
  onConfirm
}) => {
  const { t } = useTranslation();
  return (
    <ConfirmationModal
      isOpen={open}
      setIsOpen={(value) => {
        const next = typeof value === "function" ? value(open) : value;
        if (!next) onCancel();
      }}
      data-test="hide-value-modal"
      hideDivider
      title={t(`${TRANSLATION_KEY}.title`, 'Hide "{{name}}"?', {
        name: valueName
      })}
      confirmationTextVariant="body"
      confirmationText={
        <>
          {t(
            `${TRANSLATION_KEY}.body.line1`,
            "Some records currently use this value."
          )}
          <br />
          {t(
            `${TRANSLATION_KEY}.body.line2`,
            "Hiding it won't change any existing data. It won't be available from now on."
          )}
        </>
      }
      submitButtonText={t(`${TRANSLATION_KEY}.confirm`, "Hide value")}
      cancelButtonText={t("common.cancel", "Cancel")}
      handleSubmit={onConfirm}
      handleCancel={onCancel}
    />
  );
};

export default HideValueModal;
